export default __webpack_public_path__ + "static/media/location-icon-green.5af9b471.svg";